import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { postService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as groupActions from './actions';

export function fetchGroups(action$) {
  return action$
    .pipe(
      ofType(actionTypes.FETCH_GROUPS_COLLECTION),
      mergeMap(({ payload }) => {
        return postService.getGroups(payload)
          .pipe(
            map(res => groupActions.fetchGroupsSuccess(res.responceObject.records)),
            catchError(error => {
              console.log(error)
            })
          )
      })
    )
}